export const queryParamsKeys = {
  REDIRECT_URL_AFTER_LOGIN_SUCCESS: 'return_path', // Do not change this value because it is being used by the backend during the pronnect connexion process
  ERROR: 'error',
};
